import React, { useEffect } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Home = () => {
  const { username } = useSelector((state) => state.authState);

  useEffect(() => {
    document.title = "Dashboard | Ledger";
  }, []);

  return (
    <div className="home-bg">
      <div className="container py-5">
        {/* Header Section */}
        <div className="d-flex justify-content-between align-items-end mb-5">
          <div>
            <span className="text-uppercase tracking-wider text-muted small fw-bold">Financial Overview</span>
            <h1 className="fw-bold m-0">Hello, {username?.name || "Member"} 👋</h1>
          </div>
          <div className="text-end d-none d-md-block">
            <p className="text-muted m-0">{new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
          </div>
        </div>

        <h5 className="mb-4 fw-bold">Services</h5>
        <div className="row g-4">
          {/* ACTIVE CARD: LEDGER */}
          <div className="col-12 col-md-6 col-lg-3">
            <Link to="/detail" className="text-decoration-none">
              <div className="service-card active-card">
                <div className="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/></svg>
                </div>
                <h4>Ledger</h4>
                <p>Track your daily transactions and balances.</p>
                <span className="status-badge">Active</span>
              </div>
            </Link>
          </div>

          {/* UPCOMING CARDS */}
          {["Analytics", "Invoices", "Settings"].map((item) => (
            <div className="col-12 col-md-6 col-lg-3" key={item}>
              <div className="service-card upcoming-card">
                <div className="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="gray" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                </div>
                <h4>{item}</h4>
                <p>This feature is currently under development.</p>
                <span className="status-badge-muted">Coming Soon</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;